<script setup>
import { useVModel } from '@vueuse/core'

defineEmits(['updated-input']);

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  options: {
    type: Array,
    default: () => {
      return [];
    }
  },
});

let model = useVModel(props, 'modelValue')
</script>

<template>
  <select
      v-model="model"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm leading-6 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5"
      @blur="$emit('updated-input')"
  >
    <template
        v-for="(option, options_index) in props.options"
        :key="options_index"
    >
      <option
          :value="option.value"
      >
        {{ option.label }}
      </option>
    </template>
  </select>
</template>


